import React, { useState, useEffect, useMemo } from 'react'
import { formatFirebaseTimestamp, displayEventSchedule, timestampToMillis } from '../../utils/datetime'
import HandymanIcon from '@mui/icons-material/Handyman';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import Create from './Create';
import EventDetailModal from '../components/EventDetailModal';

export default function Events({ user, events, toggleConfirmDialog }) {

    const [inEditMode, setinEditMode] = useState(false);
    const [eventDataToEdit, seteventDataToEdit] = useState({});
    const [detailEvent, setDetailEvent] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortDesc, setSortDesc] = useState(true);

    const filteredEvents = useMemo(() => {
        const query = searchQuery.toLowerCase().trim();
        const filtered = !query ? events : events.filter(e =>
            e?.id?.toLowerCase().includes(query) ||
            e?.title?.toLowerCase().includes(query) ||
            e?.type?.toLowerCase().includes(query)
        );
        return [...filtered].sort((a, b) => {
            const diff = timestampToMillis(a?.createdAt) - timestampToMillis(b?.createdAt);
            return sortDesc ? -diff : diff;
        });
    }, [events, searchQuery, sortDesc]);

    function toggleEditMode(eventData) {
        setinEditMode(true);
        seteventDataToEdit(eventData);

    }

    return (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {!inEditMode && (
                <div className="users-search-container">
                    <SearchIcon sx={{ color: '#6c757d', fontSize: '20px' }} />
                    <input
                        type="text"
                        placeholder="Search by ID, title or type..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="users-search-input"
                    />
                    {searchQuery && (
                        <ClearIcon
                            sx={{ color: '#adb5bd', fontSize: '18px', cursor: 'pointer', '&:hover': { color: '#6c757d' } }}
                            onClick={() => setSearchQuery('')}
                        />
                    )}
                </div>
            )}
            {inEditMode ? (
                <Create
                    user={user}
                    editMode={true}
                    eventData={eventDataToEdit}
                    goBack={() => {
                        setinEditMode(false);
                        seteventDataToEdit({});
                    }}
                />
            ) : (
                <table className="request-table">
                    <thead>
                        <tr>
                            <th style={{ width: '280px' }}>ID</th>
                            <th>Title</th>
                            <th>Date & Time</th>
                            <th>Type</th>
                            <th>Format</th>
                            <th>Repeat</th>
                            <th style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => setSortDesc(d => !d)}>
                                Created {sortDesc ? '▼' : '▲'}
                            </th>
                            <th style={{ textAlign: 'right', width: '140px' }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredEvents.length === 0 ? (
                            <tr>
                                <td colSpan="8" className="empty-state">
                                    {searchQuery ? 'No events match your search' : 'No events found'}
                                </td>
                            </tr>
                        ) : filteredEvents.map((event, index) => (
                            <tr key={index} className="request-row" style={{ cursor: 'pointer' }} onClick={() => setDetailEvent(event)}>
                                <td style={{ fontFamily: 'monospace', fontSize: '12px', color: '#6c757d' }}>
                                    {event?.id}
                                </td>
                                <td style={{ fontWeight: 500, color: '#1a1a2e' }}>{event?.title}</td>
                                <td>{displayEventSchedule(event)}</td>
                                <td>
                                    <span style={{
                                        padding: '4px 8px',
                                        backgroundColor: '#f0f0f0',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        fontWeight: 500
                                    }}>
                                        {event?.type}
                                    </span>
                                </td>
                                <td style={{ textTransform: 'capitalize' }}>{event?.connectionType || 'event'}</td>
                                <td style={{ textTransform: 'capitalize' }}>{event?.repeat || '—'}</td>
                                <td style={{ color: '#6c757d', fontSize: '13px' }}>{formatFirebaseTimestamp(event?.createdAt)}</td>
                                <td onClick={(e) => e.stopPropagation()}>
                                    <div className="table-actions">
                                        <div
                                            onDoubleClick={() => toggleConfirmDialog(
                                                true, 
                                                event.isLive ? 'Deactivate live event?' : 'Set Event to LIVE. Are you sure?', 
                                                event.isLive ? 'deactivateEvent' : 'activateEvent', 
                                                event.id
                                            )} 
                                            className={`status-badge ${event.isLive ? 'live' : 'inactive'}`}
                                        >
                                            {event.isLive ? 'Live' : 'Inactive'}
                                        </div>
                                        <HandymanIcon 
                                            onClick={() => toggleEditMode(event)} 
                                            sx={{ color: '#adb5bd', cursor: 'pointer', fontSize: '20px', '&:hover': { color: 'var(--color-primary)' } }} 
                                        />
                                        <DeleteForeverIcon 
                                            className="delete-icon"
                                            onClick={() => toggleConfirmDialog(true, 'DELETE Event. Are you sure?', 'deleteEvent', event.id)} 
                                            sx={{ color: '#adb5bd', cursor: 'pointer', fontSize: '20px', '&:hover': { color: '#dc3545' } }} 
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            {detailEvent && (
                <EventDetailModal
                    event={detailEvent}
                    onClose={() => setDetailEvent(null)}
                />
            )}
        </div>
    )
}